(function () {
  'use strict';

  angular.module('sempraWebapp').factory('devicesStore', devicesStoreFactory);

  /** @ngInject */
  function devicesStoreFactory (dispatcher, EventEmitter, deviceActions, ActionTypesEnum) {
    var DevicesStore = new EventEmitter(),
      devicesImmutable = null;

    DevicesStore.events = Object.freeze({
      CHANGE: 'change'
    });

    DevicesStore.getDevices = function () {
      return devicesImmutable !== null
        ? devicesImmutable.toJSON()
        : null;
    };

    DevicesStore.getDevice = function () {
      return devicesImmutable !== null
          ? devicesImmutable.toJSON()
          : null;
    };

    DevicesStore.getDeviceBySerial = function (deviceSerial) {
      if (devicesImmutable === null) {
        return null;
      }

      var result = devicesImmutable.toJSON().find(function (deviceJson) {
        return deviceJson.deviceKey === deviceSerial;
      });

      return result ? result : null;
    };

    DevicesStore.dispatchToken = dispatcher.register(function (actionData) {
      switch (actionData.type) {
        case ActionTypesEnum.GET_DEVICES:
          devicesImmutable = Immutable.fromJS(actionData.payload);
          DevicesStore.emit(DevicesStore.events.CHANGE);
          break;
        case ActionTypesEnum.GET_KARCHER_DEVICE:
          devicesImmutable = Immutable.fromJS(actionData.payload);
          DevicesStore.emit(DevicesStore.events.CHANGE);
          break;
      }
    });

    return DevicesStore;
  }
})();
